import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const isAuth = localStorage.getItem('auth') === 'true';
    const role = localStorage.getItem('role');
    const ownerId = localStorage.getItem('ownerId');
    const userId = localStorage.getItem('userId');

    useEffect(() => {
        setIsLoaded(true);
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleProfileClick = () => {
        if (!isAuth) {
            navigate('/login');
        } else if (role === 'admin') {
            navigate('/admin-panel');
        } else if (role === 'owner' && ownerId) {
            navigate(`/owner-panel/${ownerId}`);
        } else if (role === 'user' && userId) {
            navigate(`/profile/${userId}`);
        } else {
            navigate('/login');
        }
    };

    // Menü item'ları
    const menuItems = [
        { label: 'Ana Sayfa', path: '/' },
        { label: 'Profil', path: '/profile' },
        { label: 'Kayıt Ol', path: '/signup', auth: false },
        { label: 'Giriş Yap', path: '/login', auth: false },
        { label: 'Çıkış', path: '/login', auth: true, logout: true },
    ];

    return (
        <header className={`sticky top-0 z-50 bg-gradient-to-r from-[#241c15] via-[#523323] to-[#7F6B52] shadow-2xl shadow-black/40 transition-all duration-500 ${scrolled ? 'py-2 md:py-4' : 'py-4 md:py-6'}`}>
            <div className="container mx-auto flex items-center justify-between px-4 md:px-8">
                {/* Logo + Başlık */}
                <div
                    onClick={() => { navigate('/'); setMenuOpen(false); }}
                    className="flex items-center gap-4 cursor-pointer group"
                >
                    <div className={`backdrop-blur-lg bg-white/10 border border-[#F9D923]/30 rounded-2xl px-4 py-2 flex items-center gap-3 shadow-xl transition-all duration-700 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'} group-hover:scale-105 group-hover:shadow-2xl group-hover:ring-2 group-hover:ring-[#F9D923]/40`}>

                        {/* GÜNCELLENMİŞ LOGO */}
                        <img
                            src={logo}
                            alt="Kirtepan Logo"
                            className="h-12 w-12 rounded-full drop-shadow-lg group-hover:drop-shadow-[0_0_20px_rgba(255,255,255,0.5)] transition-all duration-300"
                        />

                        <h1 className="hidden md:block text-3xl lg:text-4xl font-extrabold bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] text-transparent bg-clip-text drop-shadow-[2px_2px_8px_rgba(0,0,0,0.4)] tracking-wider group-hover:scale-110 group-hover:brightness-125 transition-all duration-500">
                            Kirtepan
                        </h1>
                    </div>
                </div>


                {/* Hamburger Icon - Mobile */}
                <div className="md:hidden">
                    <button
                        aria-label="Menüyü Aç/Kapat"
                        onClick={() => setMenuOpen(!menuOpen)}
                        className={`relative inline-block px-4 py-3 rounded-full bg-white/20 border border-[#F9D923]/30 shadow-md hover:shadow-lg hover:bg-white/30 transition-all duration-500 focus:outline-none focus:ring-2 focus:ring-[#F9D923] transform ${menuOpen ? 'rotate-180' : 'rotate-0'}`}
                    >
                        <svg
                            className="h-8 w-8 text-[#F9D923] transition-transform duration-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d={menuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
                            />
                        </svg>
                    </button>
                </div>

                {/* Masaüstü Menü */}
                {/* Masaüstü Menü */}
                <nav className={`hidden md:flex items-center gap-2 ...`}>
                    <HeaderButton onClick={() => { setMenuOpen(false); navigate('/'); }}>Ana Sayfa</HeaderButton>

                    {/* SADECE GİRİŞ YAPTIYSA GÖRÜNSÜN */}
                    {isAuth && (
                        <HeaderButton onClick={() => { setMenuOpen(false); handleProfileClick(); }}>Profil</HeaderButton>
                    )}

                    {isAuth ? (
                        <HeaderButton red onClick={() => {
                            localStorage.removeItem('auth');
                            localStorage.removeItem('role');
                            localStorage.removeItem('ownerId');
                            localStorage.removeItem('userId');
                            setMenuOpen(false);
                            navigate('/login');
                        }}>Çıkış</HeaderButton>
                    ) : (
                        <>
                            <HeaderButton onClick={() => { setMenuOpen(false); navigate('/signup'); }}>Kayıt Ol</HeaderButton>
                            <HeaderButton onClick={() => { setMenuOpen(false); navigate('/login'); }}>Giriş Yap</HeaderButton>
                        </>
                    )}
                </nav>


                {/* Mobil Menü */}
                {menuOpen && (
                    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-gradient-to-br from-[#241c15] via-[#523323] to-[#7F6B52] bg-opacity-95 backdrop-blur-xl">
                        <button
                            aria-label="Menüyü Kapat"
                            onClick={() => setMenuOpen(false)}
                            className="absolute top-6 right-6 text-[#F9D923] text-4xl font-bold focus:outline-none animate-pulse hover:animate-none"
                        >
                            ×
                        </button>
                        <div className="flex flex-col gap-8 items-center w-full max-w-xs mt-12">
                            {[
                                { label: 'Ana Sayfa', onClick: () => navigate('/') },
                                { label: 'Profil', onClick: handleProfileClick },
                                ...(isAuth
                                    ? [{
                                        label: 'Çıkış', onClick: () => {
                                            localStorage.removeItem('auth');
                                            localStorage.removeItem('role');
                                            localStorage.removeItem('ownerId');
                                            localStorage.removeItem('userId');
                                            navigate('/login');
                                        }, red: true
                                    }]
                                    : [
                                        { label: 'Kayıt Ol', onClick: () => navigate('/signup') },
                                        { label: 'Giriş Yap', onClick: () => navigate('/login') }
                                    ])
                            ].map((item, index) => (
                                <HeaderButton
                                    key={index}
                                    big
                                    red={item.red}
                                    onClick={() => {
                                        item.onClick();
                                        setMenuOpen(false);
                                    }}
                                    style={{
                                        animation: `fadeInUp 0.5s ease-out ${index * 0.1 + 0.3}s forwards`,
                                        opacity: 0,
                                        transform: 'translateY(20px)'
                                    }}
                                >
                                    {item.label}
                                </HeaderButton>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* Tailwind'e özel animasyonlar */}
            <style jsx>{`
                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fade-in {
                    animation: fadeIn 0.5s ease-out forwards;
                }
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
            `}</style>
        </header>
    );
}

// HeaderButton: Premium buton tasarımı
function HeaderButton({ children, onClick, red, big, active, style }) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <button
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={`relative inline-block px-7 py-3 rounded-full font-semibold tracking-wide transition-all duration-500 cursor-pointer overflow-hidden group text-center
                ${red
                    ? 'text-white bg-transparent hover:text-red-400 border border-red-400'
                    : 'text-white bg-transparent hover:text-[#F9D923] border border-[#F9D923]/40'}
                shadow-md hover:shadow-xl
                before:absolute before:inset-0 before:rounded-full before:bg-gradient-to-r before:from-[#F9D923] before:via-[#FF914D] before:to-[#7F6B52] before:opacity-0 before:transition-all before:duration-500 group-hover:before:opacity-30
                ${big ? 'text-3xl py-6 w-full mx-auto my-2' : 'text-base md:text-base'}
                ${active ? 'ring-2 ring-[#F9D923] ring-offset-2' : ''}
            `}
            style={style}
            tabIndex={0}
        >
            <span className={`relative z-10 drop-shadow-lg transition-all duration-300 ${isHovered ? 'scale-105' : 'scale-100'}`}>
                {children}
            </span>
            {/* Hover efekti için dekoratif element */}
            {isHovered && (
                <span className="absolute -bottom-1 left-1/2 w-0 h-1 bg-[#F9D923] transform -translate-x-1/2 group-hover:w-4/5 transition-all duration-500 rounded-full"></span>
            )}
        </button>
    );
}